import { render, staticRenderFns } from "./MobileProfile.vue?vue&type=template&id=5ab8ea20&scoped=true"
import script from "./MobileProfile.vue?vue&type=script&lang=js"
export * from "./MobileProfile.vue?vue&type=script&lang=js"
import style0 from "./MobileProfile.vue?vue&type=style&index=0&id=5ab8ea20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8ea20",
  null
  
)

export default component.exports